@let dialog = this.dialogStore.activeDialog();
@if (dialog) {
  <lib-modal (close)="closeDialog()" [show]="true" [contentRef]="content" [title]="dialog.title" [primaryButton]="dialog.primaryButton"
             [secondaryButton]="dialog.secondaryButton" [canCloseWithoutAction]="dialog.canCloseWithoutAction"
             [leftButton]="dialog.leftButton">
    <ng-template #content>
      <div class="flex flex-col gap-[16px]">
      @if (dialog.message) {
        <span class="content-regular text-foreground-75 leading-[24px]">{{dialog.message | translate }}</span>
      }
      @if (dialog.warningMessage) {
        <lib-text-alert [text]="dialog.warningMessage" type="warning"></lib-text-alert>
      }
      @if(dialog.input) {
        <lib-input-wrapper [label]="dialog.input.label" [required]="dialog.input.required">
          <lib-input
            [placeholder]="dialog.input.placeholder" 
            [state]="dialog.input.errorMessage?.() ? 'error' : 'default'"
            [value]="dialog.input.value?.()"
            (valueChange)="inputValueChange($event, dialog)">
          </lib-input>
          <lib-support-message [message]="dialog.input.errorMessage?.()"></lib-support-message>
        </lib-input-wrapper>
      }

      @if (dialog?.template) {
        <ng-container *ngTemplateOutlet="dialog.template"></ng-container>
      }
      </div>
    </ng-template>
  </lib-modal>

}

